/**
 * Short hype lines shown on the speed-up banner that bridges each
 * infinite-mode repeat from loop 3 onward (loop 2 — the first repeat —
 * gets the dedicated "INFINITE MODE" finale instead).
 *
 * Indexed by loop so consecutive repeats always read a different line and
 * the sequence is deterministic (handy for tests / replays). Keep each one
 * short — it has to land in a glance during a ~1s count-in — and upbeat.
 */
const LOOP_HYPE_MESSAGES: readonly string[] = [
  'No brakes on this thing.',
  'Your fingers versus physics.',
  'Faster — because you asked for it.',
  "Blink and you'll miss it.",
  'The metronome is sweating.',
  'Speedrun your own song.',
  'Hope you stretched first.',
  'This is fine. Everything is fine.',
  'Warp speed engaged.',
  'Are you even human?',
  'The notes are running now.',
  'Turbo button: located.',
  'Reflexes loading… done.',
  'One more. Just one more.',
  'Gravity wants a rematch.',
  'Showing off now, are we?',
];

/**
 * Pick the hype line for a given loop. `loopIndex` 2 is the first
 * banner-eligible repeat, so it maps to the first message; later loops
 * walk the list and wrap once exhausted.
 */
export function loopHypeMessage(loopIndex: number): string {
  const offset = Math.max(0, loopIndex - 2);
  return LOOP_HYPE_MESSAGES[offset % LOOP_HYPE_MESSAGES.length];
}
